var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 289274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_575_9747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5587 1.87164C22.5873 0.84264 23.4464 0.0234649 24.4693 0.138995C28.2401 0.564891 31.8482 1.96066 34.9349 4.20423C38.5257 6.81418 41.2429 10.4493 42.7296 14.6321C44.2163 18.8148 44.4029 23.3494 43.2648 27.6401C42.2865 31.3285 40.3687 34.6884 37.7126 37.3986C36.992 38.1338 35.8087 38.0406 35.1371 37.2605L30.3926 31.7491C29.721 30.9689 29.8239 29.8004 30.4796 29.0069C31.4863 27.7886 32.2235 26.3617 32.6324 24.8201C33.2015 22.6747 33.1082 20.4074 32.3648 18.316C31.6215 16.2247 30.2629 14.4071 28.4675 13.1021C27.1773 12.1643 25.705 11.5228 24.1552 11.2132C23.1457 11.0115 22.3284 10.1701 22.357 9.14105L22.5587 1.87164Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5587 1.87164C22.5873 0.84264 23.4464 0.0234649 24.4693 0.138995C28.2401 0.564891 31.8482 1.96066 34.9349 4.20423C38.5257 6.81418 41.2429 10.4493 42.7296 14.6321C44.2163 18.8148 44.4029 23.3494 43.2648 27.6401C42.2865 31.3285 40.3687 34.6884 37.7126 37.3986C36.992 38.1338 35.8087 38.0406 35.1371 37.2605L30.3926 31.7491C29.721 30.9689 29.8239 29.8004 30.4796 29.0069C31.4863 27.7886 32.2235 26.3617 32.6324 24.8201C33.2015 22.6747 33.1082 20.4074 32.3648 18.316C31.6215 16.2247 30.2629 14.4071 28.4675 13.1021C27.1773 12.1643 25.705 11.5228 24.1552 11.2132C23.1457 11.0115 22.3284 10.1701 22.357 9.14105L22.5587 1.87164Z",
    fill: "url(#paint0_linear_575_9747)",
    stroke: "white",
    strokeWidth: 1.49111,
    mask: "url(#path-1-inside-1_575_9747)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 7",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_575_9747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0557 37.3301C35.7232 38.1138 35.6331 39.2974 34.7957 39.8961C32.412 41.6004 29.7065 42.8151 26.8357 43.462C23.3573 44.2457 19.7407 44.1722 16.297 43.248C12.8534 42.3237 9.68598 40.5763 7.06755 38.1563C4.44912 35.7362 2.45813 32.716 1.26601 29.3556C0.0738884 25.9953 -0.28364 22.3956 0.224211 18.8665C0.732066 15.3373 2.09008 11.9845 4.18132 9.09663C6.27256 6.20879 9.03436 3.87251 12.2289 2.28893C14.8655 0.981935 17.7317 0.22001 20.6565 0.0410784C21.684 -0.0217801 22.4999 0.840426 22.4756 1.86954L22.3038 9.13972C22.2795 10.1688 21.42 10.9672 20.4016 11.1168C19.2625 11.2841 18.1529 11.6297 17.1144 12.1445C15.5172 12.9363 14.1363 14.1044 13.0906 15.5483C12.045 16.9922 11.366 18.6687 11.1121 20.4332C10.8582 22.1978 11.0369 23.9977 11.633 25.6778C12.229 27.358 13.2245 28.8681 14.5338 30.0781C15.843 31.2882 17.4267 32.1619 19.1485 32.624C20.8703 33.0861 22.6787 33.1228 24.4178 32.731C25.5485 32.4762 26.6279 32.0453 27.6177 31.4573C28.5027 30.9316 29.6731 31.0099 30.3406 31.7936L35.0557 37.3301Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0557 37.3301C35.7232 38.1138 35.6331 39.2974 34.7957 39.8961C32.412 41.6004 29.7065 42.8151 26.8357 43.462C23.3573 44.2457 19.7407 44.1722 16.297 43.248C12.8534 42.3237 9.68598 40.5763 7.06755 38.1563C4.44912 35.7362 2.45813 32.716 1.26601 29.3556C0.0738884 25.9953 -0.28364 22.3956 0.224211 18.8665C0.732066 15.3373 2.09008 11.9845 4.18132 9.09663C6.27256 6.20879 9.03436 3.87251 12.2289 2.28893C14.8655 0.981935 17.7317 0.22001 20.6565 0.0410784C21.684 -0.0217801 22.4999 0.840426 22.4756 1.86954L22.3038 9.13972C22.2795 10.1688 21.42 10.9672 20.4016 11.1168C19.2625 11.2841 18.1529 11.6297 17.1144 12.1445C15.5172 12.9363 14.1363 14.1044 13.0906 15.5483C12.045 16.9922 11.366 18.6687 11.1121 20.4332C10.8582 22.1978 11.0369 23.9977 11.633 25.6778C12.229 27.358 13.2245 28.8681 14.5338 30.0781C15.843 31.2882 17.4267 32.1619 19.1485 32.624C20.8703 33.0861 22.6787 33.1228 24.4178 32.731C25.5485 32.4762 26.6279 32.0453 27.6177 31.4573C28.5027 30.9316 29.6731 31.0099 30.3406 31.7936L35.0557 37.3301Z",
    fill: "url(#paint1_linear_575_9747)",
    fillOpacity: 0.8,
    stroke: "white",
    strokeWidth: 1.49111,
    mask: "url(#path-2-inside-2_575_9747)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_9747",
    x1: 29.8314,
    y1: 22.2424,
    x2: 23.4576,
    y2: -86.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B59F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B59F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_575_9747",
    x1: 14.1686,
    y1: 21.7576,
    x2: 20.5424,
    y2: 130.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B59F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B59F8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPai);
export default __webpack_public_path__ + "static/media/pai.8f29a3de0c2c1820291028d877a8b3a2.svg";
export { ForwardRef as ReactComponent };